<template>
  <a-modal title="企业详情" style="top: 20px;" :width="1350" v-model="visible" :confirmLoading="confirmLoading"
    @cancel="handleClose" :footer="null" :maskClosable="false" destroyOnClose>
    <div class="table-page-search-wrapper">
      <a-tabs :activeKey="activeKey" @change="callback">
        <a-tab-pane v-if="enterpriseInfo && permissionsView" tab="企业信息" key="1">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" :form="form" :class="[enterpriseShow == 0 ? 'disEvents' : '']">
              <label class="threela">基本信息</label>
              <a-row :gutter="6">
                <a-col :span="6">
                  <a-form-item label="企业名称">
                    <a-input v-decorator="['enterpriseName', { rules: [{ required: true, message: '请输入企业名称' }] }]"
                      :disabled="!editCommonInfo" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="注册人">
                    <a-input v-decorator="['register']" :disabled="!editBasicInnerInfo" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="联系方式">
                    <a-input v-decorator="['registerPhone']" :disabled="!editBasicInnerInfo" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="注册时间">
                    <a-date-picker v-model="createTime" style="width: 100%" format="YYYY-MM-DD HH:mm"
                      :disabled="!editBasicInnerInfo" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="企业简称">
                    <a-input v-decorator="['enterpriseSysName', { rules: [{ required: true, message: '请输入企业简称' }] }]"
                      :disabled="!editCommonInfo" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="市场负责人">
                    <a-select :allowClear="true" v-decorator="['marketPrincipal']" :disabled="!editBasicInnerInfo">
                      <a-select-option v-for="user in marketPrincipalMap" :key="user.userId">
                        {{ user.userName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="默认安装类别">
                    <a-select :allowClear="true" :options="installTypeMap" v-decorator="['defaultInstallType']"
                      :disabled="!editCommonInfo" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="企业账号">
                    <a-input :disabled="true" v-decorator="['loginName']" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="账号姓名">
                    <a-input :disabled="true" v-decorator="['userName']" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="手机号">
                    <a-input :disabled="true" v-decorator="['phone']" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="企业类型">
                    <a-select v-decorator="['types']" :disabled="true">
                      <a-select-option :value="0">锁企</a-select-option>
                      <a-select-option :value="1">电信公司</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="6">
                <a-col :span="24">
                  <a-row type="flex" justify="space-between" align="bottom">
                    <label style="margin-right: -20px;">安装类别</label>
                    <a-checkbox-group @change="onChangeInstall" :options="installTypeMap"
                      style="width: calc(100% - 100px)" v-model="enterprise.installTypes" :disabled="!editCommonInfo" />
                  </a-row>
                </a-col>
              </a-row>
              <a-tabs @change="onChangeinstallTab" type="card" style="margin-top: 20px">
                <a-tab-pane v-for="item in installTabs" :tab="item.label" :key="item.value">
                  <a-row :gutter="6" style="margin-top: 15px;">
                    <a-col :span="6">
                      <a-form-item label="负责人">
                        <a-input v-decorator="['principalName$' + item.value]" :disabled="!editCommonInfo"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="负责人电话">
                        <a-input v-decorator="['principalPhone$' + item.value]" :disabled="!editCommonInfo" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="技术人员">
                        <a-input v-decorator="['techniqueName$' + item.value]" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="技术电话">
                        <a-input v-decorator="['techniquePhone$' + item.value]" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="技术人员2">
                        <a-input v-decorator="['techniqueName2$' + item.value]" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="技术2电话">
                        <a-input v-decorator="['techniquePhone2$' + item.value]" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="客服负责人">
                        <a-input v-decorator="['customerServiceName$' + item.value]" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="客服负责人电话">
                        <a-input v-decorator="['customerServicePhone$' + item.value]" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-tab-pane>
              </a-tabs>
              <div style="margin-top: 40px;">
                <label class="threela">企业档案</label>
                <a-row :gutter="6" style="margin-top: 10px;">
                  <a-col :span="6" v-if="viewPrincipalInfo">
                    <a-form-item label="企业负责人">
                      <a-input v-decorator="['enterprisePrincipal']" :disabled="!editPrincipalInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewPrincipalInfo">
                    <a-form-item label="企业负责人电话">
                      <a-input v-decorator="['enterprisePrincipalPhone']" :disabled="!editPrincipalInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewPrincipalInfo">
                    <a-form-item label="财务负责人">
                      <a-input v-decorator="['financePrincipal']" :disabled="!editPrincipalInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewPrincipalInfo">
                    <a-form-item label="财务负责人电话">
                      <a-input v-decorator="['financePrincipalPhone']" :disabled="!editPrincipalInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
                      <a-select :options="payTypeMap" v-decorator="['enterprisePayType']" :disabled="!editAccountInfo"
                        :allowClear="true"></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="结算周期">
                      <a-select :options="settleCycleMap" v-decorator="['enterpriseSettlementType']" :allowClear="true"
                        @change="changeSettlementType" :disabled="!editAccountInfo"></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="回款方式">
                      <a-select :allowClear="true" :options="returnMoneyMap" v-decorator="['returnedMoneyType']"
                        @change="changeMoneyType" :disabled="!editAccountInfo"></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item label="回款日">
                      <a-select :allowClear="true" :options="moneyDateMap" v-decorator="['returnedMoneyDate']"
                        :disabled="!editAccountInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业开票">
                      <a-select :allowClear="true" :options="enterpriseInvoiceMap" v-decorator="['enterpriseInvoice']"
                        :disabled="!editAccountInfo"></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item label="发票抬头">
                      <a-input v-decorator="['invoiceTitle']" :disabled="!editAccountInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发票类型">
                      <a-select :allowClear="true" :options="invoiceTypeMap" v-decorator="['invoiceType']"
                        :disabled="!editAccountInfo">
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item label="税号">
                      <a-input v-decorator="['enterpriseTaxNo']" :disabled="!editAccountInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item label="开户行">
                      <!--<a-input  v-decorator="['enterpriseCardorg']" :disabled="!editAccountInfo"/>-->
                      <a-select showSearch optionFilterProp="children" v-decorator="['enterpriseCardorg']"
                        :filterOption="filterOption" :disabled="!editAccountInfo" allowClear="true">
                        <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{
                          item.name
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item label="银行卡账号">
                      <a-input v-decorator="['enterpriseCardNumber']" :disabled="!editAccountInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12" v-if="viewAccountInfo">
                    <a-form-item label="地址">
                      <a-select :allowClear="true" v-decorator="['province']" style="width: 20%;margin-right: 1%"
                        @change="changeProvince" :disabled="!editAccountInfo">
                        <a-select-option v-for="type in provinceMap" :key="type.provinceCode">
                          {{ type.provinceName }}
                        </a-select-option>
                      </a-select>
                      <a-select :allowClear="true" v-decorator="['city']" style="width: 20%;margin-right: 1%"
                        @change="changeCity" :disabled="!editAccountInfo">
                        <a-select-option v-for="type in cityMap" :key="type.cityCode">{{
                          type.cityName
                        }}</a-select-option>
                      </a-select>
                      <a-select :allowClear="true" v-decorator="['area']" style="width: 20%;margin-right: 1%"
                        @change="changeAddress" :disabled="!editAccountInfo">
                        <a-select-option v-for="type in areaMap" :key="type.areaCode">{{
                          type.areaName
                        }}</a-select-option>
                      </a-select>
                      <a-input v-decorator="['enterpriseAddress']" style="width: 37%" :disabled="!editAccountInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item label="电话">
                      <a-input v-decorator="['enterpriseMobile']" :disabled="!editAccountInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="税率承担方">
                      <a-select :allowClear="true" :options="enterpriseTaxMap" v-decorator="['enterpriseTax']"
                        :disabled="!editAccountInfo"></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewAccountInfo">
                    <a-form-item label="企业承担税点">
                      <a-input v-decorator="['enterpriseTaxPoint']" :disabled="!editAccountInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewInnerInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业星级">
                      <a-select :allowClear="true" v-decorator="['enterpriseStar']" :options="enterpriseLevelMap"
                        :disabled="!editInnerInfo"></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewInnerInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业下单">
                      <a-select :allowClear="true" v-decorator="['enterpriseImportanceType']" :options="importanceTypeMap"
                        @change="handChange" :disabled="!editInnerInfo"></a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label="自定义信息1">
                      <a-input v-decorator="['info1']" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label="自定义信息2">
                      <a-input v-decorator="['info2']" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item label="自定义信息3">
                      <a-input v-decorator="['info3']" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="isShow == 1 && viewInnerInfo">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单负责人">
                      <a-select showSearch optionFilterProp="children" :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      " :allowClear="true" v-decorator="['orderPrincipals']" mode="multiple"
                        :disabled="!editInnerInfo">
                        <a-select-option v-for="user in userMap" :key="user.userId">
                          {{ user.userName }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <span style="margin: 0 10px 0 55px">销单码 : </span>
                    <a-switch v-model="needSaleOrderCode2" :class="[enterpriseShow == 0 ? 'disEvents' : '']"
                      :disabled="store.getters.userType != '00'" default-checked @change="onChange" />
                  </a-col>
                  <a-col :span="6">
                    <span style="margin: 0 10px 0 15px">是否使用配件 : </span>
                    <a-switch v-model="needAccessories" :class="[enterpriseShow == 0 ? 'disEvents' : '']"
                      default-checked />
                  </a-col>
                  <a-col :span="6"><a-button v-if="enterpriseShow == 1" :disabled="store.getters.userType != '00'"
                      type="primary" @click="configModel()" class="twobtn">
                      配置型号
                    </a-button></a-col>
                </a-row>
                <a-row type="flex" justify="space-between" style="margin-top: 20px;" v-if="queryList">
                  <a-col :span="24">
                    <a-spin :spinning="spinning">
                      <a-table size="default" ref="table" :pagination="pagination" :columns="columns"
                        :dataSource="enterprise.enterpriseContracts" bordered>
                        <span slot="action2" slot-scope="text, record">
                          <a v-if="addEnable" @click="delsee(record)">查看</a>
                          <a-divider type="vertical" v-if="addEnable" />
                          <a v-if="addEnable" @click="delByIds(record)">下载</a>
                          <a-divider v-if="addEnable" type="vertical" />
                          <a v-if="record.forbiddenStatus == 1" @click="enableContract(record.id)">启用</a>
                          <a v-else @click="disableContract(record.id)">禁用</a>
                          <a-divider type="vertical" v-if="removeEnable" />
                          <a-popconfirm title="确认删除吗？" @confirm="() => delContract(record.id)">
                            <a v-if="removeEnable">删除</a>
                          </a-popconfirm>
                        </span>
                        <span slot="contractNo" slot-scope="text, record">
                          <a-input :disabled="!editEnabel" v-model="record.contractNo"
                            @blur="onblurContractNo(record.contractNo, record.id)" />
                        </span>
                        <span slot="contractName" slot-scope="text, record">
                          <a-input :disabled="!editEnabel" v-model="record.contractName"
                            @blur="onblurContractName(record.contractName, record.id)" />
                        </span>
                        <span slot="isMainContract" slot-scope="text, record">
                          <a-switch :disabled="!editEnabel" v-model="record.isMainContract == 1"
                            @change="onChangeSwitch(record, record.isMainContract, record.id)" />
                          主合同
                        </span>
                        <span slot="contractTime" slot-scope="text, record">
                          <a-range-picker v-decorator="['time']" format="YYYY-MM-DD"
                            @change="onChangeContractTime(record.id, $event)" :disabled="!editEnabel" />
                        </span>
                      </a-table>
                    </a-spin>
                  </a-col>
                </a-row>
                <a-row type="flex" justify="start" style="margin-top: 15px" v-if="queryList">
                  <a-col :span="3">
                    <a-upload name="file" :fileList="fileList1" :action="uploadUrlb2" :headers="headers"
                      @change="uploadChange" :beforeUpload="beforeUpload" showUploadList="false">
                      <a-button :disabled="!editEnabel" v-if="enterpriseShow == 1" class="twobtn"
                        style="margin-left: 10px;" type="primary">上传</a-button>
                    </a-upload>
                  </a-col>
                  <a-col :span="21"></a-col>
                </a-row>
                <a-row style="margin: 20px 0px 50px 0px;" v-if="viewInnerInfo">
                  <a-col :span="12">
                    <a-form-item label="企业备注" style="width: 704px;">
                      <a-textarea :rows="4" v-decorator="['content']" :disabled="!editInnerInfo" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12"></a-col>
                </a-row>
              </div>
              <!-- 旧件寄回地址 -->
              <div class="mtb-40">
                <label style="color: #2D93F2;">旧件寄回地址</label>
                <div class="flex">
                  <label style="color: #2D93F2;"></label>
                  <a-button v-if="enterpriseShow == 1" :disabled="sendRequestList.length == 5"
                    @click="sendRequestAdd">添加寄件要求</a-button>
                </div>
                <div v-for="(item, index) in sendRequestList" :key="index">
                  <a-row style="margin-top: 10px" :gutter="16">
                    <a-col :span="6">
                      <a-form-item label="寄件要求" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input v-model.trim="item.requirement" :maxlength="20" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">

                      <a-popconfirm placement="top" ok-text="确定" cancel-text="取消" @confirm="sendRequestDel(index)">
                        <template slot="title">
                          <p>删除后该寄件要求不可使用！</p>
                        </template>
                        <a-tag color="cyan" v-if="enterpriseShow == 1">
                          删除
                        </a-tag>
                      </a-popconfirm>
                      <!-- <a-button size="small" @click="sendBackOldHandleDel(index)">删除</a-button> -->

                    </a-col>
                  </a-row>
                </div>
                <div class="flex mt-10">
                  <label style="color: #2D93F2;"></label>
                  <a-button v-if="enterpriseShow == 1" :disabled="sendBackOldPiecesList.length == 5"
                    @click="sendBackOldPiecesAdd">添加寄回地址</a-button>
                </div>
                <div v-for="(item, index) in sendBackOldPiecesList" :key="index">
                  <a-row style="margin-top: 10px" :gutter="16">
                    <a-col :span="6">
                      <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input v-model.trim="item.contact" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input @blur="changePhone" v-model.trim="item.phoneNumber" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input v-model.trim="item.address" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <div class="flex">
                        <!-- <span>是否默认</span> -->
                        <!-- :defaultChecked="index == 0 ? true : false" -->
                        <div>
                          <span class="mr-10">是否默认:</span>
                          <a-switch :defaultChecked="index == 0 ? true : false"
                            :checked="item.defaultStatus == 0 ? true : false" @click="switchChange(index)" />
                        </div>

                        <a-popconfirm placement="top" ok-text="确定" cancel-text="取消"
                          @confirm="sendBackOldHandleDel(index)">
                          <template slot="title">
                            <p>删除后该地址则不可使用！</p>
                          </template>
                          <a-tag color="cyan" v-if="enterpriseShow == 1">
                            删除
                          </a-tag>
                        </a-popconfirm>
                        <!-- <a-button size="small" @click="sendBackOldHandleDel(index)">删除</a-button> -->
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </div>
              <div>
                <a-col :span="24" style="display: flex;justify-content: center;">
                  <a-button v-if="enterpriseShow == 1" type="primary" @click="handleSubmit" html-type="submit">
                    提交
                  </a-button>
                </a-col>
              </div>
            </a-form>
          </div>
        </a-tab-pane>
        <a-tab-pane v-if="priceInfo" tab="金额信息" key="2" forceRender>
          <a-tabs :default-active-key="defaultActive" type="card" @change="callback1" v-if="enterprisePrice.length > 0">
            <a-tab-pane v-for="item in this.enterprisePrice" :tab="item.installType"
              :key="item.data[0].installationTypeCode">
              <a-form :class="[enterpriseShow == 0 ? 'disEvents' : '']">
                <a-row v-for="price in item.data" :key="price.enterprisePriceId" type="flex" justify="space-around"
                  :gutter="24">
                  <a-col :span="6" v-if="viewEnterprisePrice">
                    <a-form-item :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" :label="price.priceType"
                      style="width: 300px;">
                      <a-input v-model="price.price" :disabled="!editPriceInfo" />
                    </a-form-item>
                  </a-col>
                  <!--<a-col :span="3" v-if="viewPriceInfo">-->
                  <!--<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="width: 270px;">-->
                  <!--<a-switch v-model="price.application" /> 可申请-->
                  <!--</a-form-item>-->
                  <!--</a-col>-->
                  <a-col :span="8" v-if="viewEnterprisePrice">
                    <a-form-item label="比例不得超过" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select style="width: 200px;" show-search :allowClear="true" option-filter-prop="children"
                        :filter-option="filterOption" :disabled="!editPriceInfo" v-model="price.orderType">
                        <a-select-option v-for="type in orderTypeMap" :key="type.value">{{
                          type.label
                        }}</a-select-option>
                      </a-select>
                      <a-input v-model="price.proportion" style="width: 40px;margin-left:10px;"
                        :disabled="!editPriceInfo" />
                      <span>%</span>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6" v-if="viewPriceInfo">
                    <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input v-model="price.priceRemark" :disabled="!editPriceInfo" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="24" style="display: flex;justify-content: center;">
                    <a-button type="primary" @click="priceSubmit(item.data)" html-type="submit">
                      提交
                    </a-button>
                  </a-col>
                </a-row>
              </a-form>
            </a-tab-pane>
            <a-tab-pane tab="配件">
              <div v-for="item in this.enterpriseAccessoryPrice" :key="item.enterpriseAccessoryId"
                :class="[enterpriseShow == 0 ? 'disEvents' : '']">
                <label class="threela">{{ item.installType }}</label>
                <a-table size="default" ref="table" :pagination="pagination" :columns="accessoryPriceColumns"
                  :dataSource="item.data" bordered>
                  <span slot="priceThreshold" slot-scope="text, record">
                    <a-input v-model="record.accessoryPriceThreshold"
                      @blur="onblurPriceThreshold(record.accessoryPriceThreshold, record.enterpriseAccessoryId)" />
                  </span>
                  <span slot="remark" slot-scope="text, record">
                    <a-input v-model="record.remark" @blur="onblurRemark(record.remark, record.enterpriseAccessoryId)" />
                  </span>
                </a-table>
              </div>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
        <a-tab-pane v-if="setEnterprise && permissionsView" tab="企业设置" key="3">
          <a-tabs type="card" @change="callback2">
            <a-tab-pane v-for="item in this.enterpriseGuarantee" :key="item.installType" :tab="item.installTypeName"
              :class="[enterpriseShow == 0 ? 'disEvents' : '']">
              <a-row>
                <a-col :span="4">
                  <a-form-item>
                    <a-switch v-model="item.smsNoticeFlag" :disabled="!editEnterpriseSetting" /> 短信提醒
                  </a-form-item>
                </a-col>

                <a-col :span="4">
                  <a-form-item>
                    <a-switch v-model="item.serialNoFlag" :disabled="!editEnterpriseSetting" /> 产品条形码
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="企业加急比例" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                    <a-input-number v-model="item.urgentRatio" :min="0" :max="100" :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')" :disabled="!editEnterpriseSetting" />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="产品条形码示例图" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                    <div class="clearfix">
                      <a-upload :action="uploadUrlPic" list-type="picture-card" :file-list="picList" :headers="headers"
                        @preview="handlePicPreview" @beforeUpload="beforePicUpload" @change="handlePicChange"
                        :remove="handleRemove">
                        <div v-if="picList.length < 3 && enterpriseShow == 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">
                            上传
                          </div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewPicVisible" :footer="null" @cancel="handlePicCancel">
                        <img alt="example" style="width: 100%" :src="previewPicImage" />
                      </a-modal>
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <br />
              <a-row>
                <a-col :span="24" style="text-align: right">
                  <a-button type="primary" @click="addGuarantee(item.data)" style="margin: 10px 10px 10px 0px"
                    :disabled="!editEnterpriseSetting">新增</a-button>
                </a-col>
              </a-row>
              <a-table size="default" ref="table" :pagination="pagination" :columns="guaranteeColumns"
                :dataSource="item.data" bordered>
                <span slot="operate" slot-scope="text, record">
                  <a class="iconfont" style="margin-right: 5px;" @click="delGuarantee(item.data, record)"
                    :disabled="!editEnterpriseSetting">&#xe870;</a>
                </span>
                <span slot="orderType" slot-scope="text, record">
                  <a-select style="width: 150px;" :allowClear="true" :disabled="!editEnterpriseSetting"
                    v-model="record.orderType" :filter-option="filterOption" :options="orderTypeMap1"
                    option-filter-prop="children" show-search />
                </span>
                <span slot="guaranteeTime" slot-scope="text, record">
                  <a-input v-model="record.guaranteeTime" placeholder="请输入保质期时间(单位:天)"
                    :disabled="!editEnterpriseSetting" />
                </span>
                <span slot="relationOrderType" slot-scope="text, record">
                  <a-select style="width: 380px;" :allowClear="true" :disabled="!editEnterpriseSetting" mode="multiple"
                    v-model="record.relationOrderType" :filter-option="filterOption" :options="orderTypeMap1"
                    option-filter-prop="children" show-search />
                </span>
                <span slot="guaranteeRemark" slot-scope="text, record">
                  <a-input v-model="record.remark" :disabled="!editEnterpriseSetting" />
                </span>
              </a-table>
              <a-col :span="24" style="display: flex;justify-content: center;margin-top: 10px">
                <a-button type="primary" @click="guaranteeSubmit(item)" html-type="submit"
                  :disabled="!editEnterpriseSetting">
                  提交
                </a-button>
              </a-col>
            </a-tab-pane>
          </a-tabs>
          <div style="margin-top: 40px;">
            <a-tabs type="card" @change="callbackSet">
              <a-tab-pane tab="下单要求" key="1" :class="[enterpriseShow == 0 ? 'disEvents' : '']">
                <a-table size="default" ref="table" :pagination="pagination" :columns="demandColumns"
                  :dataSource="createOrderDemand" bordered>
                  <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                    <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">配置</a-button>
                    <span v-if="record.editable">
                      <a-button type="primary" style="margin-right: 10px"
                        @click="() => demandSubmit(record.key, 'createOrderDemand')">保存</a-button>
                      <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'createOrderDemand')">
                        <a-button style="margin-right: 10px">取消</a-button>
                      </a-popconfirm>
                    </span>
                    <span v-else>
                      <a-button :disabled="isEditing || !editEnterpriseRequest"
                        @click="() => demandEdit(record.key, 'createOrderDemand')" type="primary"
                        style="margin-right: 10px">编辑</a-button>
                    </span>
                    <a-button type="primary" v-if="record.disabledFlag == 0" @click="disableDemand(record.demandId)"
                      style="margin-right: 10px" :disabled="!editEnterpriseRequest">禁用</a-button>
                    <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">启用</a-button>
                    <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!deleteEnterpriseRequest">删除</a-button>
                  </template>
                  <template slot="demandContent" slot-scope="text, record, index">
                    <div>
                      <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                        @change="e => demandChange(e.target.value, record.key, 'createOrderDemand')" />
                      <template v-else>
                        {{ text }}
                      </template>
                    </div>
                  </template>
                </a-table>
                <template>
                  <a-textarea v-model="createOrderDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px"
                    :disabled="!addEnterpriseRequest" />
                  <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('create_order_demand')"
                    :disabled="isEditing || !addEnterpriseRequest">提交</a-button>
                </template>
                <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                  <div class="clearfix">
                    <a-upload :action="uploadUrlb" list-type="picture-card" :file-list="fileList" :headers="headers"
                      @preview="handlePreview" @change="handleChange" :disabled="!addEnterpriseRequest">
                      <div>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">上传</div>
                      </div>
                    </a-upload>
                    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                      <img alt="example" style="width: 100%" :src="previewImage" />
                    </a-modal>
                  </div>
                  <a-col :span="24" style="display: flex;justify-content: center;">
                    <a-button type="primary" @click="picSubmit('create_order_demand')" html-type="submit">
                      提交
                    </a-button>
                  </a-col>
                </a-form-item>
              </a-tab-pane>
              <a-tab-pane tab="派单要求" :class="[enterpriseShow == 0 ? 'disEvents' : '']" key="2">
                <a-table size="default" ref="table" :pagination="pagination" :columns="demandColumns"
                  :dataSource="dispatchOrderDemand" bordered>
                  <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                    <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">配置</a-button>
                    <span v-if="record.editable">
                      <a-button type="primary" style="margin-right: 10px"
                        @click="() => demandSubmit(record.key, 'dispatchOrderDemand')">保存</a-button>
                      <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'dispatchOrderDemand')">
                        <a-button type="primary" style="margin-right: 10px">取消</a-button>
                      </a-popconfirm>
                    </span>
                    <span v-else>
                      <a-button :disabled="isEditing || !editEnterpriseRequest"
                        @click="() => demandEdit(record.key, 'dispatchOrderDemand')" type="primary"
                        style="margin-right: 10px">编辑</a-button>
                    </span>
                    <a-button type="primary" v-if="record.disabledFlag == 0" @click="disableDemand(record.demandId)"
                      style="margin-right: 10px" :disabled="!editEnterpriseRequest">禁用</a-button>
                    <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">启用</a-button>
                    <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!deleteEnterpriseRequest">删除</a-button>
                  </template>
                  <template slot="demandContent" slot-scope="text, record, index">
                    <div>
                      <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                        @change="e => demandChange(e.target.value, record.key, 'dispatchOrderDemand')" />
                      <template v-else>
                        {{ text }}
                      </template>
                    </div>
                  </template>
                </a-table>
                <template>
                  <a-textarea v-model="dispatchOrderDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px"
                    :disabled="!addEnterpriseRequest" />
                  <a-button type="primary" style="margin-bottom: 20px"
                    @click="demandContentSubmit('dispatch_order_demand')"
                    :disabled="isEditing || !addEnterpriseRequest">提交</a-button>
                </template>
                <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                  <div class="clearfix">
                    <a-upload :action="uploadUrlb" list-type="picture-card" :file-list="fileList2" :headers="headers"
                      @preview="handlePreview2" @change="handleChange2" :disabled="!addEnterpriseRequest">
                      <div>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">上传</div>
                      </div>
                    </a-upload>
                    <a-modal :visible="previewVisible2" :footer="null" @cancel="handleCancel2">
                      <img alt="example" style="width: 100%" :src="previewImage2" />
                    </a-modal>
                  </div>
                  <a-col :span="24" style="display: flex;justify-content: center;">
                    <a-button type="primary" @click="picSubmit('dispatch_order_demand')" html-type="submit">
                      提交
                    </a-button>
                  </a-col>
                </a-form-item>
              </a-tab-pane>
              <a-tab-pane tab="金额要求" :class="[enterpriseShow == 0 ? 'disEvents' : '']" key="3">
                <a-table size="default" ref="table" :pagination="pagination" :columns="demandColumns"
                  :dataSource="priceDemand" bordered>
                  <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                    <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">配置</a-button>
                    <span v-if="record.editable">
                      <a-button type="primary" style="margin-right: 10px"
                        @click="() => demandSubmit(record.key, 'priceDemand')">保存</a-button>
                      <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'priceDemand')">
                        <a-button type="primary" style="margin-right: 10px">取消</a-button>
                      </a-popconfirm>
                    </span>
                    <span v-else>
                      <a-button :disabled="isEditing || !editEnterpriseRequest"
                        @click="() => demandEdit(record.key, 'priceDemand')" type="primary"
                        style="margin-right: 10px">编辑</a-button>
                    </span>
                    <a-button type="primary" v-if="record.disabledFlag == 0" @click="disableDemand(record.demandId)"
                      style="margin-right: 10px" :disabled="!editEnterpriseRequest">禁用</a-button>
                    <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">启用</a-button>
                    <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!deleteEnterpriseRequest">删除</a-button>
                  </template>
                  <template slot="demandContent" slot-scope="text, record, index">
                    <div>
                      <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                        @change="e => demandChange(e.target.value, record.key, 'priceDemand')" />
                      <template v-else>
                        {{ text }}
                      </template>
                    </div>
                  </template>
                </a-table>
                <template>
                  <a-textarea v-model="priceDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px"
                    :disabled="!addEnterpriseRequest" />
                  <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('price_demand')"
                    :disabled="isEditing || !addEnterpriseRequest">提交</a-button>
                </template>
                <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                  <div class="clearfix">
                    <a-upload :action="uploadUrlb" list-type="picture-card" :file-list="fileList3" :headers="headers"
                      @preview="handlePreview3" @change="handleChange3" :disabled="!addEnterpriseRequest">
                      <div>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">上传</div>
                      </div>
                    </a-upload>
                    <a-modal :visible="previewVisible3" :footer="null" @cancel="handleCancel3">
                      <img alt="example" style="width: 100%" :src="previewImage3" />
                    </a-modal>
                  </div>
                  <a-col :span="24" style="display: flex;justify-content: center;">
                    <a-button type="primary" @click="picSubmit('price_demand')" html-type="submit">
                      提交
                    </a-button>
                  </a-col>
                </a-form-item>
              </a-tab-pane>
              <a-tab-pane tab="师傅要求" :class="[enterpriseShow == 0 ? 'disEvents' : '']" key="4">
                <a-table size="default" ref="table" :pagination="pagination" :columns="demandColumns"
                  :dataSource="masterDemand" bordered>
                  <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                    <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">配置</a-button>
                    <span v-if="record.editable">
                      <a-button type="primary" style="margin-right: 10px"
                        @click="() => demandSubmit(record.key, 'masterDemand')">保存</a-button>
                      <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'masterDemand')">
                        <a-button type="primary" style="margin-right: 10px">取消</a-button>
                      </a-popconfirm>
                    </span>
                    <span v-else>
                      <a-button :disabled="isEditing || !editEnterpriseRequest"
                        @click="() => demandEdit(record.key, 'masterDemand')" type="primary"
                        style="margin-right: 10px">编辑</a-button>
                    </span>
                    <a-button type="primary" v-if="record.disabledFlag == 0" @click="disableDemand(record.demandId)"
                      style="margin-right: 10px" :disabled="!editEnterpriseRequest">禁用</a-button>
                    <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">启用</a-button>
                    <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!deleteEnterpriseRequest">删除</a-button>
                  </template>
                  <template slot="demandContent" slot-scope="text, record, index">
                    <div>
                      <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                        @change="e => demandChange(e.target.value, record.key, 'masterDemand')" />
                      <template v-else>
                        {{ text }}
                      </template>
                    </div>
                  </template>
                </a-table>
                <template>
                  <a-textarea v-model="masterDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px"
                    :disabled="!addEnterpriseRequest" />
                  <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('master_demand')"
                    :disabled="isEditing || !addEnterpriseRequest">提交</a-button>
                </template>
                <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                  <div class="clearfix">
                    <a-upload :action="uploadUrlb" list-type="picture-card" :file-list="fileList4" :headers="headers"
                      @preview="handlePreview4" @change="handleChange4" :disabled="!addEnterpriseRequest">
                      <div>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">上传</div>
                      </div>
                    </a-upload>
                    <a-modal :visible="previewVisible4" :footer="null" @cancel="handleCancel4">
                      <img alt="example" style="width: 100%" :src="previewImage4" />
                    </a-modal>
                  </div>
                  <a-col :span="24" style="display: flex;justify-content: center;">
                    <a-button type="primary" @click="picSubmit('master_demand')" html-type="submit">
                      提交
                    </a-button>
                  </a-col>
                </a-form-item>
              </a-tab-pane>
              <a-tab-pane tab="核销要求" :class="[enterpriseShow == 0 ? 'disEvents' : '']" key="5">
                <a-table size="default" ref="table" :pagination="pagination" :columns="demandColumns"
                  :dataSource="writeoffDemand" bordered>
                  <template slot="demandOperate" slot-scope="text, record, index" style="float: left">
                    <a-button type="primary" @click="configDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">配置</a-button>
                    <span v-if="record.editable">
                      <a-button type="primary" style="margin-right: 10px"
                        @click="() => demandSubmit(record.key, 'writeoffDemand')">保存</a-button>
                      <a-popconfirm title="确定取消吗?" @confirm="() => demandCancel(record.key, 'writeoffDemand')">
                        <a-button type="primary" style="margin-right: 10px">取消</a-button>
                      </a-popconfirm>
                    </span>
                    <span v-else>
                      <a-button :disabled="isEditing || !editEnterpriseRequest"
                        @click="() => demandEdit(record.key, 'writeoffDemand')" type="primary"
                        style="margin-right: 10px">编辑</a-button>
                    </span>
                    <a-button type="primary" v-if="record.disabledFlag == 0" @click="disableDemand(record.demandId)"
                      style="margin-right: 10px" :disabled="!editEnterpriseRequest">禁用</a-button>
                    <a-button v-else type="primary" @click="enableDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!editEnterpriseRequest">启用</a-button>
                    <a-button type="primary" @click="deleteDemand(record.demandId)" style="margin-right: 10px"
                      :disabled="!deleteEnterpriseRequest">删除</a-button>
                  </template>
                  <template slot="demandContent" slot-scope="text, record, index">
                    <div>
                      <a-input v-if="record.editable" style="margin: -5px 0" :value="text"
                        @change="e => demandChange(e.target.value, record.key, 'writeoffDemand')" />
                      <div v-else>
                        {{ text }}
                      </div>
                    </div>
                  </template>
                </a-table>
                <template>
                  <a-textarea v-model="writeoffDemandContent" :rows="4" style="width: 50%;margin: 20px 20px 20px 0px"
                    :disabled="!addEnterpriseRequest" />
                  <a-button type="primary" style="margin-bottom: 20px" @click="demandContentSubmit('writeoff_demand')"
                    :disabled="isEditing || !addEnterpriseRequest">提交</a-button>
                </template>
                <a-form-item label="要求图片" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                  <div class="clearfix">
                    <a-upload :action="uploadUrlb" list-type="picture-card" :file-list="fileList5" :headers="headers"
                      @preview="handlePreview5" @change="handleChange5" :disabled="!addEnterpriseRequest">
                      <div>
                        <a-icon type="plus" />
                        <div class="ant-upload-text">上传</div>
                      </div>
                    </a-upload>
                    <a-modal :visible="previewVisible5" :footer="null" @cancel="handleCancel5">
                      <img alt="example" style="width: 100%" :src="previewImage5" />
                    </a-modal>
                  </div>
                  <a-col :span="24" style="display: flex;justify-content: center;">
                    <a-button type="primary" @click="picSubmit('writeoff_demand')" html-type="submit">
                      提交
                    </a-button>
                  </a-col>
                </a-form-item>
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-tab-pane>
        <a-tab-pane tab="企业履历" v-if="permissionsView" key="4">
          <div class="table-page-search-wrapper">
            <a-form :form="form7" layout="inline" @submit="handleSubmit7">
              <a-row :gutter="16">
                <!--<a-col :span="6">-->
                <!--<a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
                <!--<a-select v-model="queryParam7.masterType"  allowClear="true">-->
                <!--<a-select-option  v-for="type in restaurantTypes" :key="type.code">{{type .label}}</a-select-option>-->
                <!--</a-select>-->
                <!--</a-form-item>-->
                <!--</a-col>-->
                <a-col :span="6">
                  <a-form-item label="操作模块" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam9.module" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="操作类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam9.operateType" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="操作人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam9.operateBy" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker style="width:100%;" v-model="queryParam9.time" format="YYYY-MM-DD HH:mm:ss"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                      }" @change="onChange3" @ok="onOk" />
                  </a-form-item>
                </a-col>
                <a-col :span="5" :offset="19" style="text-align: right;">
                  <a-button type="primary" style="margin-right: 8px" @click="handleSelect">查询</a-button>
                  <a-button @click="handleClear">清空</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <s-table size="default" ref="table9" :loading="loading9" :columns="columns9" :data="loadData9"
            style="margin-top: 25px" bordered>
            <span slot="action9" slot-scope="text, record">
              <div style="max-height: 150px;overflow-x: auto">
                <span v-if="record.dataType == 0">{{ text }}</span>
                <div v-else-if="record.dataType == 1" v-for="(item, index) in JSON.parse(text)">
                  <p v-if="item.newValue && item.oldValue">
                    <span v-if="JSON.parse(text).length > 1">{{ index + 1 }}.</span>
                    <span>
                      【{{ item.label }}】修改前:<span>{{ item.oldValue }}</span> 修改后:<span style="color:red">{{
                        item.newValue
                      }}</span>
                    </span>
                  </p>
                  <p v-else-if="item.newValue">
                    <span v-if="JSON.parse(text).length > 1">{{ index + 1 }}.</span>
                    <span>
                      【{{ item.label }}】新增:<span style="color:red">{{ item.newValue }}</span>
                    </span>
                  </p>
                  <p v-else-if="item.oldValue">
                    <span v-if="JSON.parse(text).length > 1">{{ index + 1 }}.</span>
                    <span>
                      【{{ item.label }}】删除:<span>{{ item.oldValue }}</span>
                    </span>
                  </p>

                  <!--<p v-if="JSON.parse(text).length==1">-->
                  <!--【{{item.label}}】新增:<span style="color:red">{{item.newValue}}</span>-->
                  <!--</p>-->
                  <!--<p v-else-if="item.newValue&&item.oldValue">-->
                  <!--{{index+1}}.【{{item.label}}】修改前:<span>{{item.oldValue}}</span> 修改后:<span style="color:red">{{item.newValue}}</span>-->
                  <!--</p>-->
                  <!--<p v-else-if="item.newValue">-->
                  <!--{{index+1}}.【{{item.label}}】新增:<span style="color:red">{{item.newValue}}</span>-->
                  <!--</p>-->
                  <!--<p v-else-if="item.oldValue">-->
                  <!--{{index+1}}.【{{item.label}}】删除:<span>{{item.oldValue}}</span>-->
                  <!--</p>-->
                </div>
              </div>
            </span>
          </s-table>
        </a-tab-pane>
      </a-tabs>
    </div>
    <enterprise-details-modal ref="modal" @ok="handleOk" />
    <enterprise-demand-config ref="demand" @ok="handleOk" />
    <p-d-fmodel ref="modal2"></p-d-fmodel>
  </a-modal>
</template>

<script>
import {
  selectFindAll,
  getEnterpriseDetail,
  getselectAllProvince,
  customInfoGet,
  customInfoSave,
  getselectCityName,
  getselectAreaName,
  updateEnterprise,
  managementRecordList
} from '@/api/enterprise/enterprise'
import { findByDeptId } from '@/api/enterprise/user'
import { toMain, toNonMain, disable, enable, remove, updateContract } from '@/api/enterprise/contract'
import {
  getEnterprisePriceList,
  getEnterpriseAccessoryPrice,
  saveAccessoryPrice,
  updateEnterprisePrice,
  getOrderType,
  getOrderTypeList
} from '@/api/enterprise/price'
import {
  getGuaranteeList,
  saveEnterpriseGuarantee,
  getDemandList,
  updateDemand,
  addDemand,
  disableDemand,
  enableDemand,
  delDemand,
  demandPicAdd,
  demandPicList
} from '@/api/enterprise/guarantee'
import EnterpriseDetailsModal from './modules/EnterpriseDetailsModal'
import EnterpriseDemandConfig from './modules/EnterpriseDemandConfig'
import '@/assets/iconfont/iconfont.css'
import { getDictMap } from '../../utils/dict'
import { STable } from '@/components'
import store from '@/store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { checkPermission } from '@/utils/permissions'
import moment from 'moment'
import PDFmodel from '../master/modules/PDFmodel'
export default {
  name: 'EnterpriseDetails',
  components: {
    EnterpriseDetailsModal,
    EnterpriseDemandConfig,
    STable,
    PDFmodel
  },
  data() {
    return {
      store,
      baseUrl: 'https://lockan.obs.cn-east-3.myhuaweicloud.com/',
      bankName1: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' }
      ],
      needSaleOrderCode: '',
      needSaleOrderCode2: false,
      needAccessories: false,
      enterpriseShow: 0,
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      confirmLoading: false,
      sendBackOldPiecesList: [], // 旧件寄回地址列表
      // 寄回要求数据
      sendRequestList: [],
      queryParam7: {},
      installTypes: [],
      installTypeMap: [],
      enterprise: {},
      enterpriseId: '',
      spinning: false,
      previewVisible: false,
      permissionsView: false,
      previewVisible2: false,
      previewVisible3: false,
      previewVisible4: false,
      previewVisible5: false,
      previewImage: '',
      previewImage2: '',
      previewImage3: '',
      previewImage4: '',
      previewImage5: '',
      previewPicImage: '',
      previewPicVisible: false,
      picList: [],
      filePicPaths: [],
      queryParam9: {},
      isShow: 0,
      isEditing: false, // true 正在编辑中
      // 表头
      columns: [
        {
          title: '操作',
          width: '80px',
          dataIndex: 'action2',
          scopedSlots: { customRender: 'action2' }
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          align: 'center',
          scopedSlots: { customRender: 'contractNo' }
        },
        {
          title: '合同名称',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'contractName' },
          align: 'center'
        },
        {
          title: '有效时间',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'contractTime' },
          align: 'center'
        },
        {
          title: '是否主合同',
          dataIndex: 'isMainContract',
          scopedSlots: { customRender: 'isMainContract' },
          align: 'center'
        }
      ],
      loadData9: parameter => {
        this.queryParam9.enterpriseId = this.enterpriseId
        return managementRecordList(Object.assign(parameter, this.queryParam9))
      },
      columns9: [
        {
          title: '序号',
          width: '80px',
          dataIndex: 'no',
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align: 'center',
          width: 80
        },
        {
          title: '操作模块',
          dataIndex: 'module',
          align: 'center',
          width: 80
        },
        {
          title: '操作类型',
          dataIndex: 'operateType',
          align: 'center',
          width: 80
        },
        {
          title: '操作内容',
          dataIndex: 'operateContent',
          scopedSlots: { customRender: 'action9' }
        },
        {
          title: '操作人',
          dataIndex: 'operateBy',
          width: 80,
          align: 'center'
        },
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          align: 'center',
          width: 80
        }
      ],
      accessoryPriceColumns: [
        {
          title: '序号',
          width: '2%',
          dataIndex: 'index'
        },
        {
          title: '配件类型',
          width: '10%',
          dataIndex: 'accessoryType'
        },
        {
          title: '配件名称',
          width: '10%',
          dataIndex: 'accessoryName'
        },
        {
          title: '配件型号',
          width: '10%',
          dataIndex: 'accessoryCategory'
        },
        {
          title: '配件规格',
          width: '10%',
          dataIndex: 'accessorySpecification'
        },
        {
          title: '可使用品牌',
          width: '14%',
          dataIndex: 'brandName'
        },
        {
          title: '可使用型号',
          width: '14%',
          dataIndex: 'modelName'
        },
        {
          title: '配件金额',
          width: '10%',
          dataIndex: 'accessoryPrice'
        },
        {
          title: '金额阈值',
          width: '10%',
          dataIndex: 'accessoryPriceThreshold',
          scopedSlots: { customRender: 'priceThreshold' }
        },
        {
          title: '备注',
          width: '10%',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' }
        }
      ],
      guaranteeColumns: [
        {
          title: '操作',
          width: '4%',
          dataIndex: 'guaranteeId',
          scopedSlots: { customRender: 'operate' }
        },
        {
          title: '订单类型',
          width: '16%',
          dataIndex: 'orderType',
          scopedSlots: { customRender: 'orderType' },
          align: 'center'
        },
        {
          title: '保质期',
          width: '20%',
          dataIndex: 'guaranteeTime',
          scopedSlots: { customRender: 'guaranteeTime' },
          align: 'center'
        },
        {
          title: '关联订单类型',
          width: '30%',
          dataIndex: 'relationOrderType',
          scopedSlots: { customRender: 'relationOrderType' },
          align: 'center'
        },
        {
          title: '备注',
          width: '30%',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'guaranteeRemark' }
        }
      ],
      demandColumns: [
        {
          title: '操作',
          width: 80,
          dataIndex: 'demandId',
          scopedSlots: { customRender: 'demandOperate' }
        },
        {
          title: '要求内容',
          dataIndex: 'demandContent',
          ellipsis: true,
          scopedSlots: { customRender: 'demandContent' }
        },
        {
          title: '操作时间',
          dataIndex: 'updateTime',
          width: 200,
          align: 'center'
        },
        {
          title: '操作人',
          width: 200,
          dataIndex: 'updateBy',
          align: 'center'
        }
      ],
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      // 旧件寄回地址联系方式校验
      phoneFlag: true,
      mdl: {},
      selectedRows: [],
      visible: false,
      pagination: false,
      loading: false,
      loading9: false,
      installTabs: [],
      invoiceTypeMap: [],
      provinceMap: [],
      cityMap: [],
      areaMap: [],
      enterpriseLevelMap: [],
      importanceTypeMap: [],
      userMap: [],
      enterpriseInvoiceMap: [],
      enterpriseTaxMap: [],
      payTypeMap: [],
      settleCycleMap: [],
      returnMoneyMap: [],
      returnMoneyData: [],
      orderTypeMap: [],
      orderTypeMap1: [],
      createTime: '',
      enterpriseAccessoryPrice: [],
      enterprisePrice: [],
      enterpriseGuarantee: [],
      createOrderDemand: [],
      dispatchOrderDemand: [],
      masterDemand: [],
      priceDemand: [],
      writeoffDemand: [],
      cacheCreateOrderDemand: [],
      cacheDispatchOrderDemand: [],
      cacheMasterDemand: [],
      cachePriceDemand: [],
      cacheWriteoffDemand: [],
      createOrderDemandContent: '',
      dispatchOrderDemandContent: '',
      masterDemandContent: '',
      priceDemandContent: '',
      staType: '',
      writeoffDemandContent: '',
      // editingKey: '',
      marketPrincipalMap: [],
      moneyDateMap: [],
      moneyDayMap: [],
      moneyWeekMap: [],
      provinceAfterMap: [],
      uploadUrlPic: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=enterprise',
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=enterprise',
      uploadUrlb2: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      filePaths: [],
      filePaths2: [],
      filePaths3: [],
      filePaths4: [],
      filePaths5: [],
      activeKey: '1',
      fileList1: [],
      customInfoId: '',
      enterpriseInfo: checkPermission('viewBaseData'),
      priceInfo: checkPermission('priceInfo'),
      viewEnterprisePrice: checkPermission('viewEnterprisePrice'),
      setEnterprise: checkPermission('viewEnterpriseSetting'),
      viewPriceInfo: checkPermission('viewPriceInfo'),
      editPriceInfo: checkPermission('editPriceInfo'),
      editCommonInfo: checkPermission('editCommonInfo'),
      editBasicInnerInfo: checkPermission('editBasicInnerInfo'),
      viewPrincipalInfo: checkPermission('viewPrincipalInfo'),
      editPrincipalInfo: checkPermission('editPrincipalInfo'),
      viewAccountInfo: checkPermission('viewAccountInfo'),
      editAccountInfo: checkPermission('editAccountInfo'),
      viewInnerInfo: checkPermission('viewInnerInfo'),
      editInnerInfo: checkPermission('editInnerInfo'),
      editEnterpriseSetting: checkPermission('editEnterpriseSetting'),
      addEnterpriseRequest: checkPermission('addEnterpriseRequest'),
      editEnterpriseRequest: checkPermission('editEnterpriseRequest'),
      deleteEnterpriseRequest: checkPermission('deleteEnterpriseRequest'),
      queryList: checkPermission('enterpriseContractList:query:list'),
      editEnabel: checkPermission('editEnterpriseContract'),
      removeEnable: checkPermission('deleteEnterpriseContract'),
      addEnable: checkPermission('enterpriseContractInfo')
      // editEnterpriseContract
    }
  },
  async created() {
    selectFindAll({
      dictTypes:
        'install_type,invoice_type,enterprise_level,enterprise_importance_type,enterprise_invoice,enterprise_tax,pay_type,settle_cycle,return_money'
    }).then(res => {
      // 安装类型
      // console.log(res)
      this.installTypeArr = res.install_type
      this.installTypeArr.forEach((value, key) => {
        this.installTypeMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 发票类型
      this.invoiceTypeArr = res.invoice_type
      this.invoiceTypeArr.forEach((value, key) => {
        this.invoiceTypeMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 企业星级
      this.enterpriseLevelArr = res.enterprise_level
      this.enterpriseLevelArr.forEach((value, key) => {
        this.enterpriseLevelMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 重要程度
      this.importanceTypeArr = res.enterprise_importance_type
      this.importanceTypeArr.forEach((value, key) => {
        this.importanceTypeMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 企业开票
      this.enterpriseInvoiceArr = res.enterprise_invoice
      this.enterpriseInvoiceArr.forEach((value, key) => {
        this.enterpriseInvoiceMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 税率承担方
      this.enterpriseTaxArr = res.enterprise_tax
      this.enterpriseTaxArr.forEach((value, key) => {
        this.enterpriseTaxMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 付款方式
      this.payTypeArr = res.pay_type
      this.payTypeArr.forEach((value, key) => {
        this.payTypeMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 结算周期
      this.settleCycleArr = res.settle_cycle
      this.settleCycleArr.forEach((value, key) => {
        this.settleCycleMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 回款方式
      this.returnMoneyArr = res.return_money
      this.returnMoneyArr.forEach((value, key) => {
        this.returnMoneyData.push({ value: value.dictValue, label: value.dictLabel })
      })
    })

    // 省
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        this.provinceMap = res.rows
      }
    })

    // 回款日（月结）
    for (let i = 1; i < 29; i++) {
      this.moneyDayMap.push({ value: i, label: i })
    }

    // 回款日（周结）
    for (let i = 1; i < 8; i++) {
      this.moneyWeekMap.push({ value: i, label: i })
    }

    this.provinceAfterMap = [
      { value: '3', label: '收到发票后3个工作日' },
      { value: '7', label: '收到发票后7个工作日' },
      { value: '15', label: '收到发票后15个工作日' },
      { value: '30', label: '收到发票后30个工作日' }
    ]
  },
  mounted() {
    this.init()
  },
  computed: {
    defaultActive() {
      return this.enterprisePrice[0].data[0].installationTypeCode
    }
  },
  methods: {
    moment,
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleClose() {
      this.visible = false
      this.isEditing = false
      // console.log('关闭', this.picList);
      this.$emit('ok')
    },
    onChange(checked) {
      if (checked == false) {
        this.needSaleOrderCode = 0
      } else {
        this.needSaleOrderCode = 1
      }
    },

    // 查看
    delsee(value) {
      this.$refs.modal2.delsee(
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        value.contractPreviewAddress +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      )
    },
    // 下载
    delByIds(value) {
      window.open(
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        value.contractAddresss +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      )
    },
    beforeUpload(file) {
      let houzhui = file.name.split('.')
      houzhui = houzhui[houzhui.length - 1]
      const isJpgOrPng =
        houzhui == 'doc' ||
        houzhui == 'docx' ||
        houzhui == 'xls' ||
        houzhui == 'ppt' ||
        houzhui == 'pptx' ||
        houzhui == 'xlsx' ||
        houzhui == 'pdf'
      console.log(houzhui, isJpgOrPng)
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        return false
      }
    },
    // 上传
    uploadChange(info) {
      this.fileList1 = info.fileList
      const that = this
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        that.UpdataContract()
        that.$message.success(`上传成功`)
        this.fileList1 = []
      } else if (info.file.status === 'error') {
        this.$message.error(`上传失败`)
        this.fileList1 = []
      }
    },
    init() { },
    handleCancel() {
      this.previewVisible = false
    },
    handlePreview(file) {
      this.previewImage = file.thumbUrl || this.baseUrl + file.url
      this.previewVisible = true
    },
    beforePicUpload(file) {
      // var reader = new window.FileReader();
      // reader.onloadend = function () {
      //   file.thumbUrl = reader.result
      //   // return callback(reader.result);
      // };
      // reader.readAsDataURL(file);
    },
    handlePicPreview(file) {
      this.previewPicImage = file.thumbUrl || file.url
      this.previewPicVisible = true
    },
    handlePicCancel() {
      this.previewPicVisible = false
    },
    handleRemove(file) {
      // const index = this.picList.indexOf(file);
      // const newFileList = this.picList.slice();
      // newFileList.splice(index, 1);
      // this.picList = newFileList;
    },
    handlePicChange({ file, fileList }) {
      // this.picList = fileList
      // 将接口数据结构改成组件所需要的
      if (file.status == 'done') {
        let fileUrl = file.response ? file.response.url : {}
        fileList.splice(fileList.length - 1)
        fileList.push(
          {
            url1: fileUrl,
            url: file.response ? file.response.pathfileName : '',
            uid: file.uid
          }
        )
      }
      this.picList = fileList
      // console.log(22221111, this.picList)
    },
    handChange(e) {
      if (e == 1) {
        this.isShow = 1
      } else {
        this.isShow = 0
      }
    },
    handleChange({ fileList }) {
      // console.log(6666, fileList)
      this.fileList = fileList
      if (fileList.length === 0) {
        this.filePaths = []
      } else {
        this.filePaths = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel2() {
      this.previewVisible2 = false
    },
    handlePreview2(file) {
      this.previewImage2 = file.thumbUrl || process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      // this.previewImage2 = file.url || file.preview || file.thumbUrl;
      this.previewVisible2 = true
    },
    handleChange2({ fileList }) {
      this.fileList2 = fileList
      if (fileList.length === 0) {
        this.filePaths2 = []
      } else {
        this.filePaths2 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths2.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths2.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel3() {
      this.previewVisible3 = false
    },
    handlePreview3(file) {
      this.previewImage3 = file.thumbUrl || process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      // this.previewImage3 = file.url || file.preview || file.thumbUrl
      this.previewVisible3 = true
    },
    handleChange3({ fileList }) {
      this.fileList3 = fileList
      if (fileList.length === 0) {
        this.filePaths3 = []
      } else {
        this.filePaths3 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths3.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths3.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel4() {
      this.previewVisible4 = false
    },
    handlePreview4(file) {
      this.previewImage4 = file.thumbUrl || process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      // this.previewImage4 = file.url || file.preview || file.thumbUrl
      this.previewVisible4 = true
    },
    handleChange4({ fileList }) {
      this.fileList4 = fileList
      if (fileList.length === 0) {
        this.filePaths4 = []
      } else {
        this.filePaths4 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths4.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths4.push(fileList[i].url)
          }
        }
      }
    },
    handleCancel5() {
      this.previewVisible5 = false
    },
    // 联系方式
    changePhone(e) {
      const pwdRegex = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      if (!pwdRegex.test(e.target.value)) {
        this.$message.error('请输入11位联系方式')
        this.phoneFlag = false
      } else {
        this.phoneFlag = true
      }
    },
    handlePreview5(file) {
      this.previewImage5 = file.thumbUrl || process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      // this.previewImage5 = file.url || file.preview || file.thumbUrl
      this.previewVisible5 = true
    },
    handleChange5({ fileList }) {
      this.fileList5 = fileList
      if (fileList.length === 0) {
        this.filePaths5 = []
      } else {
        this.filePaths5 = []
        for (let i = 0; i < fileList.length; i++) {
          if (fileList[i].response !== undefined) {
            this.filePaths5.push(fileList[i].response.url)
          }
          if (fileList[i].url !== undefined) {
            this.filePaths5.push(fileList[i].url)
          }
        }
      }
    },
    // 履历检索
    handleSelect() {
      delete this.queryParam7.time
      // this.queryParam7.masterId = this.record.userId
      this.$refs.table9.refresh(true)
    },
    handleClear() {
      this.queryParam9 = {}
    },
    onChange3(date, dateString) {
      this.queryParam9.startTime = dateString[0]
      this.queryParam9.endTime = dateString[1]
    },
    onOk(value) { },
    getImgToBase64(url, callback) {
      // 将图片转换为Base64
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    callbackSet(key) {
      console.log(key)
    },
    callback(key) {
      this.activeKey = key
      if (key == 4) {
        this.$refs.table9.refresh(true)
      }
    },
    callback1(key) {
      this.orderTypeMap = []
      getOrderTypeList(key).then(res => {
        this.orderTypeArr = res.rows
        this.orderTypeArr.forEach(orderType => {
          this.orderTypeMap.push({ value: orderType.orderTypeId, label: orderType.typeName })
        })
      })
      // getOrderType().then(res => {
      //   if (res.code === 0) {
      //     this.orderTypeArr = res.rows
      //     this.orderTypeArr.forEach(orderType => {
      //       this.orderTypeMap.push(
      //         { value: orderType.orderTypeId, label: orderType.typeName }
      //       )
      //     })
      //   }
      //   console.log('下拉', this.orderTypeMap)
      // })
    },
    callback2(key) {
      this.orderTypeMap1 = []
      getOrderTypeList(key).then(res => {
        this.orderTypeArr = res.rows
        this.orderTypeArr.forEach(orderType => {
          this.orderTypeMap1.push({ value: orderType.orderTypeId, label: orderType.typeName })
        })
      })
    },
    handleOk() {
      this.$refs.table.refresh(true)
    },
    // 刷新合同文件数据
    UpdataContract() {
      getEnterpriseDetail({ enterpriseId: this.enterpriseId }).then(res => {
        this.$nextTick(() => {
          this.enterprise.enterpriseContracts = res.data.enterpriseContracts
        })

        this.spinning = false
      })
    },
    // 旧件寄回要求-添加行
    sendRequestAdd() {
      this.sendRequestList.push({
        requirement: ''
      })
    },
    // 旧件寄回要求-删除行
    sendRequestDel(index) {
      this.sendRequestList.splice(index, 1)
    },
    // 旧件寄回-添加行
    sendBackOldPiecesAdd() {
      if (this.sendBackOldPiecesList.length === 0) {
        this.sendBackOldPiecesList.push({
          contact: '',
          phoneNumber: '',
          address: '',
          defaultStatus: '0'
        })
      } else {
        this.sendBackOldPiecesList.push({
          contact: '',
          phoneNumber: '',
          address: '',
          defaultStatus: '1'
        })
      }
      this.indexSendBackOld++
    },
    // 旧件寄回-删除行
    sendBackOldHandleDel(index) {
      if (this.sendBackOldPiecesList[index].defaultStatus == 0) {
        this.sendBackOldPiecesList.splice(index, 1)
        if (this.sendBackOldPiecesList[0]) {
          this.sendBackOldPiecesList[0].defaultStatus = 0
        }
      } else {
        this.sendBackOldPiecesList.splice(index, 1)
      }
    },
    // 开关-变换
    switchChange(index) {
      const indexFind = this.sendBackOldPiecesList.findIndex(item => {
        return item.defaultStatus == 0
      })
      const defaultStatus = this.sendBackOldPiecesList[index].defaultStatus
      this.sendBackOldPiecesList[index].defaultStatus = defaultStatus == 1 ? 0 : 1
      this.sendBackOldPiecesList[indexFind].defaultStatus = index == indexFind ? 0 : 1
    },
    // 编辑
    edit(parentId, key, code, Type, permissionsView) {
      // 查询用户
      findByDeptId('103').then(res => {
        this.userMap = res
      })
      // 查询市场用户
      findByDeptId('104').then(res => {
        this.marketPrincipalMap = res
      })
      // this.permissionsView=permissionsView
      if (permissionsView == 1) {
        this.permissionsView = false
      } else {
        this.permissionsView = true
      }
      console.log('permissionsView', this.permissionsView)
      this.queryParam9 = {}
      if (Type) {
        this.staType = true
      }
      // code 0查看 1编辑
      // 自定义信息合同编号
      this.orderTypeMap1 = []
      if (code == 0) {
        this.columns = [
          {
            title: '合同编号',
            dataIndex: 'contractNo',
            scopedSlots: { customRender: 'contractNo' },
            align: 'center'
          },
          {
            title: '合同名称',
            dataIndex: 'contractName',
            scopedSlots: { customRender: 'contractName' },
            align: 'center'
          },
          {
            title: '有效时间',
            dataIndex: 'contractName',
            scopedSlots: { customRender: 'contractTime' },
            align: 'center'
          },
          {
            title: '是否主合同',
            dataIndex: 'isMainContract',
            scopedSlots: { customRender: 'isMainContract' },
            align: 'center'
          }
        ]
      } else {
        this.columns = [
          {
            title: '操作',
            width: '80px',
            dataIndex: 'action2',
            scopedSlots: { customRender: 'action2' }
          },
          {
            title: '合同编号',
            dataIndex: 'contractNo',
            scopedSlots: { customRender: 'contractNo' },
            align: 'center'
          },
          {
            title: '合同名称',
            dataIndex: 'contractName',
            scopedSlots: { customRender: 'contractName' },
            align: 'center'
          },
          {
            title: '有效时间',
            dataIndex: 'contractName',
            width: 350,
            scopedSlots: { customRender: 'contractTime' },
            align: 'center'
          },
          {
            title: '是否主合同',
            dataIndex: 'isMainContract',
            scopedSlots: { customRender: 'isMainContract' },
            align: 'center'
          }
        ]
      }
      this.enterpriseShow = code
      this.uploadUrlb2 = process.env.VUE_APP_API_BASE_URL + '/dfs/uploadContract?type=EnterpriseContract&id=' + parentId
      this.activeKey = key
      this.visible = true
      this.form.resetFields()
      this.enterpriseId = parentId
      customInfoGet({ enterpriseId: parentId }).then(res => {
        // console.log(res,'自定义')
        if (res.code == 0) {
          if (res.data) {
            this.form.setFieldsValue({
              info1: res.data.info1,
              info2: res.data.info2,
              info3: res.data.info3
            })
            this.customInfoId = res.data.customInfoId
          }
        }
      })
      getEnterpriseDetail({ enterpriseId: this.enterpriseId })
        .then(res => {
          this.enterprise = res.data
          this.sendBackOldPiecesList = res.data.contacts
          this.sendRequestList = res.data.enterpriseSendBack

          // console.log(res,'详情')
          if (res.data.enterpriseImportanceType == 1) {
            this.isShow = 1
          }
          this.needSaleOrderCode = res.data.needSaleOrderCode
          if (this.needSaleOrderCode == 0) {
            this.needSaleOrderCode2 = false
          } else {
            this.needSaleOrderCode2 = true
          }
          this.needAccessories = res.data.needAccessories == 1

          this.onChangeInstall()
          this.mdl = Object.assign(this.enterprise)

          for (var i = 0; i < this.enterprise.installTypes.length; i++) {
            this.install = this.enterprise.installTypes[i]
            // console.log(JSON.stringify(this.enterprise.installationUsers[this.install]))
            var str = JSON.stringify(this.enterprise.installationUsers[this.install])
            if (str !== '{}' && str !== undefined) {
              this.installationUser = this.enterprise.installationUsers[this.install]
              this.enterprise['principalName$' + this.install] = this.installationUser.principalName
              this.enterprise['principalPhone$' + this.install] = this.installationUser.principalPhone
              this.enterprise['techniqueName$' + this.install] = this.installationUser.techniqueName
              this.enterprise['techniquePhone$' + this.install] = this.installationUser.techniquePhone
              this.enterprise['techniqueName2$' + this.install] = this.installationUser.techniqueName2
              this.enterprise['techniquePhone2$' + this.install] = this.installationUser.techniquePhone2
              this.enterprise['customerServiceName$' + this.install] = this.installationUser.customerServiceName
              this.enterprise['customerServicePhone$' + this.install] = this.installationUser.customerServicePhone
            }
          }
          if (this.enterprise.enterpriseContracts.length > 0) {
            for (var j = 0; j < this.enterprise.enterpriseContracts.length; j++) {
              var timeBegin = this.enterprise.enterpriseContracts[j].contractStartTime
              var timeEnd = this.enterprise.enterpriseContracts[j].contractEndTime
              if (timeBegin == null) {
                this.enterprise.enterpriseContracts[j].contractTime = []
              } else {
                this.enterprise.enterpriseContracts[j].contractTime = [
                  moment(timeBegin, this.dateFormat),
                  moment(timeEnd, this.dateFormat)
                ]
              }
            }
          }

          this.createTime = moment(this.enterprise.createTime, this.dateFormat)
          this.changeProvince(this.enterprise.province)
          this.changeCity(this.enterprise.city)
          this.$nextTick(() => {
            this.form.setFieldsValue(this.enterprise)
            getEnterprisePriceList({ enterpriseId: this.enterpriseId }).then(res => {
              if (res.code === 0) {
                this.enterprisePrice = res.data

                // console.log(this.enterprisePrice)
              }
            })

            getEnterpriseAccessoryPrice(this.enterpriseId).then(res => {
              if (res.code === 0) {
                this.enterpriseAccessoryPrice = res.data
                for (let i = 0; i < this.enterpriseAccessoryPrice.length; i++) {
                  for (let j = 0; j < this.enterpriseAccessoryPrice[i].data.length; j++) {
                    this.enterpriseAccessoryPrice[i].data[j].index = j + 1
                  }
                }
              }
            })

            getGuaranteeList({ enterpriseId: this.enterpriseId }).then(res => {
              console.log(res, '企业设置table详情')
              if (res.code == 0) {
                this.enterpriseGuarantee = res.data
                let picArr = res.data[0].serialDiagram ? res.data[0].serialDiagram.split(',') : []
                let arr = []
                picArr.forEach((item, i) => {
                  arr.push({
                    url: this.baseUrl + item,
                    thumbUrl: this.baseUrl + item,
                    url1: item,
                    uid: i + 1,//必须要有uid
                  })
                })
                this.picList = arr
                // console.log(111111111111, this.picList);
                const value = this.enterpriseGuarantee[0].installType
                getOrderTypeList(value).then(res => {
                  // console.log(res)
                  this.orderTypeArr = res.rows
                  this.orderTypeArr.forEach(orderType => {
                    this.orderTypeMap1.push({ value: orderType.orderTypeId, label: orderType.typeName })
                  })
                })
              }
            })

            demandPicList({ enterpriseId: this.enterpriseId }).then(res => {
              if (res.code === 0) {
                this.fileList = []
                this.fileList2 = []
                this.fileList3 = []
                this.fileList4 = []
                this.fileList5 = []
                const that = this
                if (res.data.create_order_demand !== undefined && res.data.create_order_demand !== null) {
                  res.data.create_order_demand.forEach(pic => {
                    this.getImgToBase64(
                      process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      pic.picPath +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                      function (data) {
                        that.fileList.push({
                          uid: pic.picId,
                          thumbUrl: data,
                          url: pic.picPath
                        })
                      }
                    )
                  })
                }
                if (res.data.dispatch_order_demand !== undefined && res.data.dispatch_order_demand !== null) {
                  res.data.dispatch_order_demand.forEach(pic => {
                    this.getImgToBase64(
                      process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      pic.picPath +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                      function (data) {
                        that.fileList2.push({
                          uid: pic.picId,
                          thumbUrl: data,
                          url: pic.picPath
                        })
                      }
                    )
                  })
                }
                if (res.data.price_demand !== undefined && res.data.price_demand !== null) {
                  res.data.price_demand.forEach(pic => {
                    this.getImgToBase64(
                      process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      pic.picPath +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                      function (data) {
                        that.fileList3.push({
                          uid: pic.picId,
                          thumbUrl: data,
                          url: pic.picPath
                        })
                      }
                    )
                  })
                }
                if (res.data.master_demand !== undefined && res.data.master_demand !== null) {
                  res.data.master_demand.forEach(pic => {
                    this.getImgToBase64(
                      process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      pic.picPath +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                      function (data) {
                        that.fileList4.push({
                          uid: pic.picId,
                          thumbUrl: data,
                          url: pic.picPath
                        })
                      }
                    )
                  })
                }
                if (res.data.writeoff_demand !== undefined && res.data.writeoff_demand !== null) {
                  res.data.writeoff_demand.forEach(pic => {
                    this.getImgToBase64(
                      process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      pic.picPath +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                      function (data) {
                        that.fileList5.push({
                          uid: pic.picId,
                          thumbUrl: data,
                          url: pic.picPath
                        })
                      }
                    )
                  })
                }
              }
            })

            this.changeSettlementType(this.enterprise.enterpriseSettlementType)
            this.changeMoneyType(this.enterprise.returnedMoneyType)
            this.loadDemandList(this.enterpriseId)
          })
        })
        .catch(error => {
          console.log('错误信息' + error)
        })
    },
    loadDemandList(enterpriseId) {
      getDemandList({ enterpriseId: enterpriseId }).then(res => {
        if (res.code === 0) {
          this.createOrderDemand = res.data.demandList.create_order_demand
          if (this.createOrderDemand !== undefined) {
            this.cacheCreateOrderDemand = this.createOrderDemand.map(item => ({ ...item }))
            for (let i = 0; i < this.createOrderDemand.length; i++) {
              this.createOrderDemand[i].key = i
              this.cacheCreateOrderDemand[i].key = i
            }
          }
          this.dispatchOrderDemand = res.data.demandList.dispatch_order_demand
          if (this.dispatchOrderDemand !== undefined) {
            this.cacheDispatchOrderDemand = this.dispatchOrderDemand.map(item => ({ ...item }))
            for (let i = 0; i < this.dispatchOrderDemand.length; i++) {
              this.dispatchOrderDemand[i].key = i
              this.cacheDispatchOrderDemand[i].key = i
            }
          }
          this.masterDemand = res.data.demandList.master_demand
          if (this.masterDemand !== undefined) {
            this.cacheMasterDemand = this.masterDemand.map(item => ({ ...item }))
            for (let i = 0; i < this.masterDemand.length; i++) {
              this.masterDemand[i].key = i
              this.cacheMasterDemand[i].key = i
            }
          }
          this.priceDemand = res.data.demandList.price_demand
          if (this.priceDemand !== undefined) {
            this.cachePriceDemand = this.priceDemand.map(item => ({ ...item }))
            for (let i = 0; i < this.priceDemand.length; i++) {
              this.priceDemand[i].key = i
              this.cachePriceDemand[i].key = i
            }
          }
          this.writeoffDemand = res.data.demandList.writeoff_demand
          console.log(this.writeoffDemand)
          if (this.writeoffDemand !== undefined) {
            this.cacheWriteoffDemand = this.writeoffDemand.map(item => ({ ...item }))
            for (let i = 0; i < this.writeoffDemand.length; i++) {
              this.writeoffDemand[i].key = i
              this.cacheWriteoffDemand[i].key = i
            }
          }
        }
      })
    },
    onChangeInstall(e) {
      this.installTabs = []
      for (var i = 0; i < this.installTypeMap.length; i++) {
        this.install = this.installTypeMap[i]
        for (var j = 0; j < this.enterprise.installTypes.length; j++) {
          this.installValue = this.enterprise.installTypes[j]
          if (this.installValue === this.install.value) {
            this.installTabs.push({ value: this.install.value, label: this.install.label })
          }
        }
      }
    },
    onChangeinstallTab(e) { },
    changeProvince(e) {
      // 市
      this.cityMap = []
      this.areaMap = []
      this.form.setFieldsValue({
        city: undefined
      })
      this.form.setFieldsValue({
        area: undefined
      })
      this.form.setFieldsValue({
        enterpriseAddress: ''
      })
      this.province = { provinceCode: e }
      getselectCityName(this.province).then(res => {
        if (res.code === 0) {
          this.cityMap = res.rows
        }
      })
    },
    changeCity(e) {
      // 区
      this.areaMap = []
      this.form.setFieldsValue({
        area: ''
      })
      this.form.setFieldsValue({
        enterpriseAddress: ''
      })
      this.city = { cityCode: e }
      getselectAreaName(this.city).then(res => {
        if (res.code === 0) {
          this.areaMap = res.rows
        }
      })
    },
    changeAddress() {
      this.form.setFieldsValue({
        enterpriseAddress: ''
      })
    },
    onChangeSwitch(record, isMainContract, id) {
      console.log(record, isMainContract, id)
      const _this = this
      this.spinning = true
      this.contractInfo = {}
      this.contractInfo['contractId'] = id
      this.contractInfo['enterpriseId'] = this.enterpriseId
      console.log(typeof isMainContract, isMainContract)
      if (isMainContract === '0') {
        toMain(this.contractInfo).then(res => {
          // console.log(res)
          if (res.code == 0) {
            _this.UpdataContract()
          }
        })
      } else {
        toNonMain(this.contractInfo).then(res => {
          if (res.code == 0) {
            _this.UpdataContract()
          }
        })
      }
    },
    // 启用合同
    enableContract(id) {
      this.contractInfo = {}
      this.spinning = true
      this.contractInfo['id'] = id
      enable(this.contractInfo).then(res => {
        this.UpdataContract()
      })
    },
    // 禁用合同
    disableContract(id) {
      this.spinning = true
      this.contractInfo = {}
      this.contractInfo['id'] = id
      disable(this.contractInfo).then(res => {
        this.UpdataContract()
      })
    },
    // 删除合同
    delContract(id) {
      this.spinning = true
      this.contractInfo = {}
      this.contractInfo['ids'] = id
      remove(this.contractInfo)
      this.UpdataContract()
    },
    onblurContractNo(contractNo, id) {
      updateContract({ id: id, contractNo: contractNo }).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onblurContractName(contractName, id) {
      updateContract({ id: id, contractName: contractName }).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangeContractTime(id, date) {
      if (date) {
        this.contractStartTime = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.contractEndTime = date[1].format('YYYY-MM-DD HH:mm:ss')
        updateContract({
          id: id,
          contractStartTime: this.contractStartTime,
          contractEndTime: this.contractEndTime
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功')
            getEnterpriseDetail({ enterpriseId: this.enterpriseId }).then(res => {
              this.enterprise = res.data
              if (this.enterprise.enterpriseContracts.length > 0) {
                for (var j = 0; j < this.enterprise.enterpriseContracts.length; j++) {
                  var timeBegin = this.enterprise.enterpriseContracts[j].contractStartTime
                  var timeEnd = this.enterprise.enterpriseContracts[j].contractEndTime
                  this.enterprise.enterpriseContracts[j].contractTime = [
                    moment(timeBegin, this.dateFormat),
                    moment(timeEnd, this.dateFormat)
                  ]
                }
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    configModel() {
      this.$refs.modal.add(this.enterpriseId)
    },
    configDemand(id) {
      this.$refs.demand.config(id)
    },
    onblurPriceThreshold(priceThreshold, id) {
      saveAccessoryPrice([{ accessoryPriceThreshold: priceThreshold, enterpriseAccessoryId: id }]).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onblurRemark(remark, id) {
      saveAccessoryPrice([{ remark: remark, enterpriseAccessoryId: id }]).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    priceSubmit(data) {
      console.log('data', data)
      for (var i = 0; i < data.length; i++) {
        if (data[i].price === '') {
          data[i].price = 0
        }
      }

      console.log('data2', data)
      updateEnterprisePrice(data).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          if (this.staType) {
            this.$emit('ok')
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    addGuarantee(data) {
      data.push({ guaranteeId: '' })
    },
    delGuarantee(data, record) {
      const index = data.indexOf(record)
      if (index !== -1) {
        data.splice(index, 1)
      }
    },
    demandChange(value, key, name) {
      let newData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
      }
      const target = newData.filter(item => key === item.key)[0]
      if (target) {
        target['demandContent'] = value
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }
      }
    },
    demandCancel(key, name) {
      let newData = []
      let cacheData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
        cacheData = this.cacheCreateOrderDemand
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
        cacheData = this.cacheDispatchOrderDemand
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
        cacheData = this.cacheMasterDemand
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
        cacheData = this.cachePriceDemand
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
        cacheData = this.cacheWriteoffDemand
      }
      const target = newData.filter(item => key === item.key)[0]
      // this.editingKey = ''
      this.isEditing = false
      console.log('当前是否有编辑', this.isEditing)
      if (target) {
        Object.assign(target, cacheData.filter(item => key === item.key)[0])
        delete target.editable
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }
      }
    },
    demandSubmit(key, name) {
      let newData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
      }
      const target = newData.filter(item => key === item.key)[0]
      if (target.demandContent === '') {
        this.$message.error('要求不能为空！')
        return
      }
      // this.editingKey = ''
      this.isEditing = false
      console.log('当前是否编辑', this.isEditing)

      if (target) {
        delete target.editable
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }

        updateDemand({ demandId: target.demandId, demandContent: target.demandContent }).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    demandEdit(key, name) {
      let newData = []
      if (name === 'createOrderDemand') {
        newData = [...this.createOrderDemand]
      } else if (name === 'dispatchOrderDemand') {
        newData = [...this.dispatchOrderDemand]
      } else if (name === 'masterDemand') {
        newData = [...this.masterDemand]
      } else if (name === 'priceDemand') {
        newData = [...this.priceDemand]
      } else if (name === 'writeoffDemand') {
        newData = [...this.writeoffDemand]
      }
      const target = newData.filter(item => key === item.key)[0]
      // this.editingKey = key
      this.isEditing = true
      // console.log('编辑', this.editingKey)
      console.log('是否被编辑', this.isEditing)

      if (target) {
        target.editable = true
        if (name === 'createOrderDemand') {
          this.createOrderDemand = newData
        } else if (name === 'dispatchOrderDemand') {
          this.dispatchOrderDemand = newData
        } else if (name === 'masterDemand') {
          this.masterDemand = newData
        } else if (name === 'priceDemand') {
          this.priceDemand = newData
        } else if (name === 'writeoffDemand') {
          this.writeoffDemand = newData
        }
      }
    },
    demandContentSubmit(name) {
      const demandData = {}
      demandData.enterpriseId = this.enterpriseId
      if (name === 'create_order_demand') {
        demandData.demandContent = this.createOrderDemandContent
      }
      if (name === 'dispatch_order_demand') {
        demandData.demandContent = this.dispatchOrderDemandContent
      }
      if (name === 'master_demand') {
        demandData.demandContent = this.masterDemandContent
      }
      if (name === 'price_demand') {
        demandData.demandContent = this.priceDemandContent
      }
      if (name === 'writeoff_demand') {
        demandData.demandContent = this.writeoffDemandContent
      }
      demandData.demandType = name

      if (demandData.demandContent === '') {
        this.$message.error('要求不能为空！')
        return
      }

      addDemand(demandData).then(res => {
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.createOrderDemandContent = ''
          this.dispatchOrderDemandContent = ''
          this.masterDemandContent = ''
          this.priceDemandContent = ''
          this.writeoffDemandContent = ''
          this.loadDemandList(this.enterpriseId)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    disableDemand(id) {
      disableDemand({ demandId: id }).then(res => {
        if (res.code === 0) {
          this.$message.success('禁用成功')
          this.loadDemandList(this.enterpriseId)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    enableDemand(id) {
      enableDemand({ demandId: id }).then(res => {
        if (res.code === 0) {
          this.$message.success('启用成功')
          this.loadDemandList(this.enterpriseId)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    deleteDemand(id) {
      const that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delDemand({ demandId: id }).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.loadDemandList(that.enterpriseId)
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          console.log('Cancel')
        }
      })
      // delDemand({ 'demandId': id }).then(res => {
      //   if (res.code === 0) {
      //     this.$message.success('删除成功')
      //     this.loadDemandList(this.enterpriseId)
      //   } else {
      //     this.$message.error(res.msg)
      //   }
      // })
    },

    guaranteeSubmit(data) {
      // url1半路径
      this.picList.forEach(item => {
        if (item.response) {
          item.url1 = item.response.url
        }
      })
      // console.log(4444, this.picList)
      data['enterpriseId'] = this.enterpriseId
      data['serialDiagram'] = this.picList.map(item => item.url1).join(',')
      // console.log(data)
      if (data.serialNoFlag && this.picList.length == 0) {
        this.$message.error('产品条形码打开，至少上传一张示例图！')
      } else {
        saveEnterpriseGuarantee(data).then(res => {
          if (res.code === 0) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }

    },
    changeSettlementType(value) {
      this.form.validateFields((err, values) => {
        // console.log(values)
        if (!err) {
          this.returnedMoneyType = values['returnedMoneyType'] // 回款方式
          // console.log(value,this.returnedMoneyType)
          // 周结
          if (value === '1' || value === '2') {
            this.returnMoneyMap = this.returnMoneyData
          } else {
            this.returnMoneyMap = []
            this.moneyDateMap = []
            this.form.setFieldsValue({
              returnedMoneyDate: '',
              returnedMoneyType: ''
            })
          }
          if (value == 1 && this.returnedMoneyType == 0) {
            this.moneyDateMap = this.moneyWeekMap
          } else if (value == 2 && this.returnedMoneyType == 0) {
            this.moneyDateMap = this.moneyDayMap
          }
        }
      })
    },
    changeMoneyType(value) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.enterpriseSettlementType = values['enterpriseSettlementType']
          // 开票前
          if (value === '0') {
            // 周结
            if (this.enterpriseSettlementType === '1') {
              this.moneyDateMap = this.moneyWeekMap
            } else if (this.enterpriseSettlementType === '2') {
              // 月结
              this.moneyDateMap = this.moneyDayMap
            } else {
              this.moneyDateMap = []
              this.form.setFieldsValue({
                returnedMoneyDate: ''
              })
            }
          }
          // 开票后
          if (value === '1') {
            this.moneyDateMap = this.provinceAfterMap
          }
        }
      })
    },
    picSubmit(value) {
      this.picData = []
      this.isEditing = false
      if (value === 'create_order_demand') {
        this.picData = this.filePaths
      }
      if (value === 'dispatch_order_demand') {
        this.picData = this.filePaths2
      }
      if (value === 'price_demand') {
        this.picData = this.filePaths3
      }
      if (value === 'master_demand') {
        this.picData = this.filePaths4
      }
      if (value === 'writeoff_demand') {
        this.picData = this.filePaths5
      }
      demandPicAdd({ enterpriseId: this.enterpriseId, picType: value, filePaths: this.picData }).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.visible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          const objSave = {}
          objSave.enterpriseId = this.enterpriseId
          objSave.customInfoId = this.customInfoId
          objSave.info1 = values.info1
          objSave.info2 = values.info2
          objSave.info3 = values.info3
          objSave.needSaleOrderCode = this.needSaleOrderCode
          customInfoSave(objSave).then(res => {
            console.log(res)
          })
          values['installationUsers'] = {}
          console.log('Received values of form: ', values)
          const objArray = {}
          for (const installType of this.enterprise.installTypes) {
            const obj = {}
            obj['insatllationCode'] = installType
            for (const val in values) {
              const index = val.indexOf('$' + installType)
              if (index !== -1) {
                const tempValName = val.substr(0, index)
                obj[tempValName] = values[val]
                delete values[val]
              }
            }
            objArray[installType] = obj
          }
          this.confirmLoading = true
          values['installTypes'] = this.enterprise.installTypes
          values['installationUsers'] = objArray
          values['enterpriseId'] = this.enterpriseId
          values.needSaleOrderCode = this.needSaleOrderCode
          values.needAccessories = this.needAccessories ? 1 : 0
          values.contacts = this.sendBackOldPiecesList
          values.enterpriseSendBack = this.sendRequestList.filter(e => e.requirement != '')

          let flag = true
          this.sendBackOldPiecesList.map(item => {
            if ((item.contact == '' && item.phoneNumber == '' && item.address == '') || (item.contact && item.phoneNumber && item.address)) {

            } else {
              flag = false
              this.$message.error('旧件寄回地址填写不完整!')
            }
          })
          if (flag) {
            if (this.phoneFlag) {
              updateEnterprise(values)
                .then(res => {
                  if (res.code === 0) {
                    this.$message.success('保存成功')
                    this.$emit('ok')
                    this.visible = false
                  } else {
                    this.$message.success(res.msg)
                  }
                })
                .catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
                .finally(() => {
                  this.confirmLoading = false
                })
            } else {
              this.$message.error('请输入11位联系方式')
            }
          }
        }
      })
    },
    watch: {}
  }
}
</script>
<style scoped>
/deep/ .ant-table th {}

/deep/ .ant-table td:first-child {
  white-space: nowrap;
}

/deep/ .ant-table td {
  padding: 4px 16px !important;
}

/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item>.ant-form-item-label {
  width: 120px;
}

.threela {
  color: #2d93f2;
}

.disEvents {
  pointer-events: none;
}

.disEvents2 {}

/*.twobtn {*/
/*!*background-color: #169BD5;*!*/
/*!*color: white;*!*/
/*!*margin-top: 10px;*!*/
/*width: 110px;*/
/*font-size: 15px;*/
/*}*/

.foursp label {
  padding-right: 15px;
  color: #3babcf;
}
</style>
